import React, { useState } from "react";
import { api } from "./api";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      onLogin(await api("/api/auth/login", { method: "POST", body: { email, password } }));
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="cz login">
      <form className="login-card" onSubmit={submit}>
        <div className="brand"><span className="brand-dot" />Cozobi</div>
        <h1>Iniciar sesión</h1>
        <p className="muted">Accede a tu panel de trabajo.</p>

        <div className="field">
          <label htmlFor="email">Correo</label>
          <input id="email" type="email" autoComplete="username" value={email}
            onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </div>
        <div className="field">
          <label htmlFor="pass">Contraseña</label>
          <input id="pass" type="password" autoComplete="current-password" value={password}
            onChange={(e) => setPassword(e.target.value)} required />
        </div>

        {error && <div className="alert alert-bad">{error}</div>}

        <button className="btn btn-block" disabled={loading}>{loading ? "Entrando..." : "Entrar"}</button>
      </form>
    </div>
  );
}